export default "__VITE_ASSET__D5ptg1br__"